<template>
    <div class="navigation-preview">
        <transition name="trs-simple-fade">
            <div class="navigation-preview--background"
                    v-if="isVisible"
                    key="backdrop"
                    @click="onBackgroundClicked"/>
        </transition>

        <div class="navigation-preview--overlay"
                v-show="isVisible"
                key="overlay"
                ref="overlay"
                :class="rootClasses"
                :style="position"
                @mouseover="onHover"
                @mouseleave="onLeave"
        >
            <div class="navigation-preview--wrapper" ref="preview">
                <div class="navigation-preview--content" v-if="previewContent && previewContent.component">
                    <component :is="previewContent.component" v-bind="previewContent.props"/>
                </div>

                <div class="navigation-preview--links" v-if="previewLinks">
                    <navigation-entry class="navigation-preview--link"
                            v-for="(link, idx) in previewLinks"
                            v-if="link.label"
                            :facets="['nav-preview']"
                            :key="idx"
                            v-bind="link"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapState, mapActions } from 'vuex';
    import NavigationEntry from 'framework/components/navigation/navigation-entry/navigation-entry';
    import bemMixin from 'framework/mixins/bem';
    import smoothReflow from 'vue-smooth-reflow';

    export default {
        components: { NavigationEntry },
        mixins: [bemMixin('navigation-preview'), smoothReflow],
        props: {},

        computed: {
            ...mapState('navigation', ['previewLinks', 'isPreviewVisible', 'previewContent', 'previewAnchor']),

            rootClasses() {
                return [
                    this.bemAdd(this.isPreviewVisible ? 'active' : null),
                    this.bemAdd((this.previewContent && this.previewContent.component) ? 'base' : 'no-preview'),
                ];
            },

            position() {
                const { x, y } = this.previewAnchor;
                return `transform: translate3d(${ x }px, ${ y - 5 }px, 0)`;
            },

            hasChildLinks() {
                return this.previewLinks != null && this.previewLinks.length > 0;
            },

            isVisible() {
                return this.isPreviewVisible && this.hasChildLinks;
            },
        },

        methods: {
            ...mapActions('navigation', ['setPreviewVisibility']),
            ...mapActions('scroll', ['disableScroll']),

            onScroll() {
                this.onLeave();
            },

            onHover() {
                if (this.hasChildLinks) {
                    this.setPreviewVisibility({ isVisible: true });
                } else {
                    this.setPreviewVisibility({ isVisible: false });
                }
            },

            onLeave() {
                this.setPreviewVisibility({ isVisible: false });
            },

            onBackgroundClicked() {
                this.setPreviewVisibility({ isVisible: false });
            },
        },

        beforeDestroy() {
            document.removeEventListener('scroll', this.onScroll);
        },

        mounted() {
            document.addEventListener('scroll', this.onScroll);
            this.$smoothReflow({
                el: this.$refs.preview,
                transition: 'height 200ms ease-in-out',
            });
        },
    };
</script>
